import { IAppState } from '../../redux';
import { IAnalyticsProduct } from '../../types/analytics';
import { getAnalyticsBrand, getAnalyticsCategory } from '../../utils';
import { selectAnalyticsVariant } from './selectAnalyticsVariant';

// Эта утилита полезна только для использования в react
export const selectAnalyticsProduct = (state: IAppState): IAnalyticsProduct => {
  const {
    offer: {
      id,
      category,
      bargainTerms: { price },
    },
    user,
  } = state;

  return {
    brand: getAnalyticsBrand(user),
    // тип сделки/тип объекта
    category: getAnalyticsCategory(category),
    // id объявления
    id,
    // стоимость объекта
    price,
    // VAS
    variant: selectAnalyticsVariant(state),
  };
};
